import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './app';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <AppRouter />,
);
